import React from 'react';
import { AvButton } from '@fabric-ui/components';
import { Box, SxProps } from '@mui/material';
import { Link } from '@tanstack/react-router';

export enum DisclaimerType {
  ACCEPTABLE_USE_POLICY = 'ACCEPTABLE_USE_POLICY',
  PRODUCT_OUTPUT_DISCLAIMER = 'PRODUCT_OUTPUT_DISCLAIMER',
}

const disclaimerConfig = {
  [DisclaimerType.ACCEPTABLE_USE_POLICY]: {
    text: 'Acceptable Use Policy',
    url: 'https://help.zscaler.com/legal/acceptable-use-policy',
  },
  [DisclaimerType.PRODUCT_OUTPUT_DISCLAIMER]: {
    text: 'Product Output Disclaimer',
    url: 'https://help.zscaler.com/legal/product-output-disclaimer',
  },
};

interface CopilotDisclaimerProps {
  variant?: React.ComponentProps<typeof AvButton>['variant'];
  sx?: SxProps;
  type?: DisclaimerType;
}

const CopilotDisclaimer = ({ variant = 'link', sx = {}, type = DisclaimerType.ACCEPTABLE_USE_POLICY }: CopilotDisclaimerProps) => {
  const { text, url } = disclaimerConfig[type];

  return (
    <AvButton
      size="xSmall"
      variant={variant}
      sx={{ p: 0, fontSize: 12, display: 'contents', ...sx }}
      component={Link}
      to={url}
      target="_blank">
      {text}
    </AvButton>
  );
};

export default CopilotDisclaimer;

export const AiInteractionDisclaimer = () => (
  <Box sx={{ width: '100%', px: 3, pb: 2 }}>
    <Box
      sx={{
        fontSize: '12px',
        border: '1px solid var(--color-border-base-primary)',
        p: 1,
        borderRadius: '12px',
        backgroundColor: 'var(--color-surface-base-primary)',
      }}>
      {`You are interacting with an AI Chatbot. It is a machine learning model, and its responses may be incomplete or inaccurate.
      Please refer to Zscaler's `}
      <CopilotDisclaimer variant="primaryText" /> and{' '}
      <CopilotDisclaimer variant="primaryText" type={DisclaimerType.PRODUCT_OUTPUT_DISCLAIMER} />
    </Box>
  </Box>
);
